import { useEffect, useState } from "react";
import axios from "axios";
import "./style.css";
import { Link } from "react-router-dom";
import { getIsOverlap } from "../utils/getIsOverlap";
import { baseUrl } from "../constants/url";
import { api } from "../constants/api";
import moment from "moment";
import { createLogicalAnd } from "typescript";

const BasePriceTable = () => {
  const rows: {
    id: number;
    amount: number;
    isWeekend:Boolean;
    create_at: string;
    update_at: string;
    fromTime: string;
    toTime: string;
  }[] = [];

  const [tableData, setTableData] = useState(rows);
  const [basePriceForm, setBasePriceForm] = useState({
    amount: 0,
    fromTime: "",
    toTime: "",
    cgst: 2.50,
    sgst: 2.50,
    isWeekend:0
  });
  const [isUpdateFlag, setIsUpdateFlag] = useState(false);
  const [updateItemId, setUpdateItemId] = useState(-1);

  useEffect(() => {
    getBasePriceTable();
  }, []);

  const getBasePriceTable = async () => {
    const res = await api(true, `/admin/basePrice`, 'get')
    // axios(`${baseUrl}/basePrice`);
    setTableData(res.data.basePrice);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!isUpdateFlag) {

      try {

        let isBooked: boolean | undefined = false;
        isBooked = getIsOverlap(tableData, basePriceForm, false);

        if (isBooked === false) {
          if (basePriceForm.toTime === "00:00") {
            await api(true, `/admin/basePrice`, 'post', {
              ...basePriceForm,
              toTime: "23:59:59"
            })
          } else {
            await api(true, `/admin/basePrice`, 'post', basePriceForm)
          }
          // axios.post(`${ baseUrl }/basePrice`, basePriceForm );
          setBasePriceForm({ amount: 0, fromTime: "", toTime: "", cgst: 2.50, sgst: 2.50, isWeekend: 1 });
          getBasePriceTable();

        }

      } catch (error) {
        console.log(error);
      }

    } else {
      try {

        let isBooked: boolean | undefined = false;
        isBooked = getIsOverlap(tableData, { ...basePriceForm, id: updateItemId }, true);

        if (isBooked === false) {
          if (basePriceForm.toTime === "00:00:00") {
            await api(true, `/admin/editBasePrice/${updateItemId}`, 'put', { ...basePriceForm, fromTime: basePriceForm.fromTime, toTime: "23:59:59", cgst: basePriceForm.cgst, sgst: basePriceForm.sgst, isWeekend: basePriceForm.isWeekend })
          } else {
            await api(true, `/admin/editBasePrice/${updateItemId}`, 'put', { ...basePriceForm, fromTime: basePriceForm.fromTime, toTime: basePriceForm.toTime, cgst: basePriceForm.cgst, sgst: basePriceForm.sgst, isWeekend: basePriceForm.isWeekend })
          }
          // axios.put(`${ baseUrl }/editBasePrice/${ updateItemId }`, basePriceForm);
          getBasePriceTable();
          setBasePriceForm({ amount: 0, fromTime: "", toTime: "", cgst: 2.50, sgst: 2.50, isWeekend: 1 });
          setIsUpdateFlag(false);

        }

      } catch (error) {
        console.log(error);
      }
    }
  };
  
  
  const handleUpdate = async (item: any) => {

    if(item.fromTime && item.toTime) {

      setBasePriceForm((prev)=>({ ...prev, amount: item.amount, cgst: item.cgst, sgst: item.sgst,
        fromTime: item.fromTime,//moment().format('HH:mm:ss'), //new Date(item.fromTime).toUTCString().split(" ")[4], // moment(item.fromTime).format('HH:mm:ss'), // 
        toTime: item.toTime === "23:59:59" ? "00:00:00" : item.toTime, //new Date().toUTCString().split(" ")[4]  //moment(item.toTime).format('HH:mm:ss') //
        isWeekend:item.isWeekend+1
      }));

    }
    setIsUpdateFlag(true);
    setUpdateItemId(item.id);
  };

  const handleDelete = async (item: any) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm(`Are you sure you want to delete this base price entry?\n\nAmount: ${item.amount}\nType: ${item.isWeekend === 1 ? 'Weekend' : 'WeekDays'}\nTime: ${item.fromTime} - ${item.toTime}`);
    
    if (!isConfirmed) {
      return; // User clicked Cancel
    }

    try {
      await api(true, `/admin/basePrice/${ item.id }`, 'delete')
      // axios.delete(`${ baseUrl }/basePrice/${ item.id }`);
      let array = tableData;
      array = array.filter((itemObj: any) => itemObj.id !== item.id);
      setTableData(array);
      setIsUpdateFlag(false);

    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeHandler = (e: any) => {
    setBasePriceForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">Base Price</h2>
      <form className="form-basePrice" onSubmit={ handleSubmit }>
        <label>Amount</label>
        <input
          type="number"
          value={ basePriceForm.amount }
          name="amount"
          onChange={ (e) => handleChangeHandler(e) }
        />

        <label>Day Types</label>
        <select name="isWeekend" value={basePriceForm.isWeekend} onChange={(e)=>handleChangeHandler(e)}>
          <option value={1}>WeekDays</option>
          <option value={2}>WeekEnds</option>
        </select>

        <label>From Time</label>
        <div className="time-row">
          <input
            type="time"
            value={basePriceForm.fromTime}
            name="fromTime"
            onChange={ (e) => handleChangeHandler(e) }
          />
        </div>
        <label>To Time</label>
        <div className="time-row">
          <input
            type="time"
            value={basePriceForm.toTime}
            name="toTime"
            onChange={ (e) => handleChangeHandler(e) }
          />
        </div>
        <label>CGST</label>
        <input
          type="number"
          value={basePriceForm.cgst}
          name="cgst"
          onChange={ (e) => handleChangeHandler(e) }
          />
          <label>SGST</label>
        <input
          type="number"
          value={basePriceForm.sgst}
          name="sgst"
          onChange={ (e) => handleChangeHandler(e) }
        />
        <button className="submitbtn" type="submit" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {isUpdateFlag ? "SAVE" : "SUBMIT"}
        </button>
      </form>
      <div className="table-responsive">
        <table className="tbl styled-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>AMOUNT</th>
              <th>TYPE</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>FROM TIME</th>
              <th>TO TIME</th>
              <th style={{ minWidth: 250 }}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            { tableData.length > 0 ? (
              tableData.map((item: any) => {
                return (
                  <tr key={ item.id } style={{ height: 60 }}>
                    <td>{ item.id }</td>
                    <td>{ item.amount }</td>
                    <td>{ item.isWeekend === 1 ?  'Weekend' : 'WeekDays' }</td>
                    <td>{ item.cgst }</td>
                    <td>{ item.sgst }</td>
                    <td>
                      {item.fromTime}
                    </td>
                    <td>
                      {item.toTime}
                    </td>
                    <td style={{ display: "flex", gap: 20, alignItems: "center", justifyContent: "center", alignSelf: "center", alignContent: "center", marginTop: 8 }}>
                      <button
                        className="btn updt"
                        onClick={ () => handleUpdate(item) }
                      >
                        UPDATE
                      </button>
                      <button
                        className="btn dngr"
                        onClick={ () => handleDelete(item) }
                      >
                        DELETE
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={8} className="loader" style={{ height: 60 }}>No Base Price Available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Link to="/admin/slotPrice" className="slot">
        Slot Price
      </Link>
    </div>
  );
};

export default BasePriceTable;
